// // yellow
// export const Images = {
//   Favlogo: "/assets/img/fav_yellow.png", // No import here
//   Favlogo2: "assets/img/logo_green.png"
// };

// green
// export const Images = {
//   Favlogo: "/assets/img/fav_green.png", // No import here
//   Favlogo2: "assets/img/logo_green.png",
// };

// // red
export const Images = {
  // Favlogo: "/assets/img/fav.png", 
  Favlogo: "/assets/img/logo.png", 
  Favlogo2: "/assets/img/logo.png",
};

// // blue
// export const Images = {
//   Favlogo: "/assets/img/fav_blue.png",
//   Favlogo2: "assets/img/logo_blue.png"
// };
